import { Chip } from '@mui/material';
import React from 'react';
import ToolTipContent from './ToolTipContent';

export const BrandPortalStatusTag: React.FC<{
  label: { description?: string; color: string; title: string };
  tooltip?: boolean;
  size?: 'small' | 'medium';
}> = ({ label, tooltip }) => {
  return tooltip ? (
    <ToolTipContent tooltip text={label.description ?? ''}>
      <StatusTag label={label} />
    </ToolTipContent>
  ) : (
    <StatusTag label={label} />
  );
};

export const StatusTag: React.FC<{
  label: {
    description?: string;
    color: string;
    title: string;
  };
  size?: 'small' | 'medium';
}> = ({ label, size }) => {
  return (
    <Chip
      label={label.title}
      variant="outlined"
      size={size}
      sx={{
        color: 'white',
        backgroundColor: label.color,
        borderColor: label.color
      }}
    />
  );
};
